import { render, staticRenderFns } from "./RegisteredAccount.vue?vue&type=template&id=24b26ad5&scoped=true&"
import script from "./RegisteredAccount.vue?vue&type=script&lang=js&"
export * from "./RegisteredAccount.vue?vue&type=script&lang=js&"
import style0 from "./RegisteredAccount.vue?vue&type=style&index=0&id=24b26ad5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b26ad5",
  null
  
)

export default component.exports